import { AccessControlRes, Permissions } from "@/types/common/accessControl";

export function createPermissionsObject(data: AccessControlRes[]) : Permissions {
    let perms : Permissions = {};
    data.forEach((ac: AccessControlRes) => {
        perms[ac.title] = {
            read: ac.read,
            write: ac.write
        }
    })
    return perms;
}